import React from 'react'

const OnlineAuctionMarketPlace = () => {
  return (
    <div>OnlineAuctionMarketPlace</div>
  )
}

export default OnlineAuctionMarketPlace